<template>
    <component :is="component"></component>
</template>

<script>
import CryptoJS from "crypto-js";

export default {
    name: "DashboardLayout",
    computed: {
        component() {
            // Get user company ID
            const companyID = localStorage.getItem("companyID");
            const decrypted = CryptoJS.AES.decrypt(companyID, process.env.VUE_APP_GOOGLE_SITE_KEY).toString(CryptoJS.enc.Utf8);
            const parsed_decrypted = JSON.parse(decrypted);

            // Based on role, lazy load the corresponding component
            if (parsed_decrypted === 14) {
                return () => import("../views/dashboard/PfizerDashboard.vue");
            } else {
                return () => import("../views/dashboard/GenericDashboard.vue");
            }
        },
    },
};
</script>

<style lang="scss">
.submit.v-btn:not(.v-btn--round).v-size--default {
    height: 52px;
    width: 100%;
}

.card-ms {
    padding-bottom: 1rem;
}
</style>
